export default __webpack_public_path__ + "static/media/newdeals.21773714.png";